import {
  vs2jen2LimitedReleaseDetailConstants,
  createVs2jen2LimitedReleaseDetailConstants,
  editVs2jen2LimitedReleaseDetailConstants,
  activateVs2jen2LimitedReleaseDetailConstants,
  deactivateVs2jen2LimitedReleaseDetailConstants,
  deleteVs2jen2LimitedReleaseDetailConstants,
} from "../_redux-constants";

export function vs2jen2LimitedReleasesDetailReducer(
  state = {
    vs2jen2LimitedReleaseDetailLoading: false,
    vs2jen2LimitedReleaseDetailData: null,
    vs2jen2LimitedReleaseDetailError: null,

    createVs2jen2LimitedReleaseDetailLoading: false,
    createVs2jen2LimitedReleaseDetailData: null,
    createVs2jen2LimitedReleaseDetailError: null,

    editVs2jen2LimitedReleaseDetailLoading: false,
    editVs2jen2LimitedReleaseDetailData: null,
    editVs2jen2LimitedReleaseDetailError: null,

    activateVs2jen2LimitedReleaseDetailLoading: false,
    activateVs2jen2LimitedReleaseDetailData: null,
    activateVs2jen2LimitedReleaseDetailError: null,

    deactivateVs2jen2LimitedReleaseDetailLoading: false,
    deactivateVs2jen2LimitedReleaseDetailData: null,
    deactivateVs2jen2LimitedReleaseDetailError: null,

    deleteVs2jen2LimitedReleaseDetailLoading: false,
    deleteVs2jen2LimitedReleaseDetailData: null,
    deleteVs2jen2LimitedReleaseDetailError: null,
  },
  action
) {
  switch (action.type) {
    case vs2jen2LimitedReleaseDetailConstants.VS2JEN2_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        vs2jen2LimitedReleaseDetailLoading: true,
        vs2jen2LimitedReleaseDetailData: null,
        vs2jen2LimitedReleaseDetailError: null,
      });
    case vs2jen2LimitedReleaseDetailConstants.VS2JEN2_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        vs2jen2LimitedReleaseDetailLoading: false,
        vs2jen2LimitedReleaseDetailData: action.data,
      });
    case vs2jen2LimitedReleaseDetailConstants.VS2JEN2_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        vs2jen2LimitedReleaseDetailLoading: false,
        vs2jen2LimitedReleaseDetailData: null,
        vs2jen2LimitedReleaseDetailError: action.error,
      });
    case createVs2jen2LimitedReleaseDetailConstants.CREATE_VS2JEN2_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        createVs2jen2LimitedReleaseDetailLoading: true,
        createVs2jen2LimitedReleaseDetailData: null,
        createVs2jen2LimitedReleaseDetailError: null,
      });
    case createVs2jen2LimitedReleaseDetailConstants.CREATE_VS2JEN2_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        createVs2jen2LimitedReleaseDetailLoading: false,
        createVs2jen2LimitedReleaseDetailData: action.data,
      });
    case createVs2jen2LimitedReleaseDetailConstants.CREATE_VS2JEN2_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        createVs2jen2LimitedReleaseDetailLoading: false,
        createVs2jen2LimitedReleaseDetailData: null,
        createVs2jen2LimitedReleaseDetailError: action.error,
      });
    case editVs2jen2LimitedReleaseDetailConstants.EDIT_VS2JEN2_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        editVs2jen2LimitedReleaseDetailLoading: true,
        editVs2jen2LimitedReleaseDetailData: null,
        editVs2jen2LimitedReleaseDetailError: null,
      });
    case editVs2jen2LimitedReleaseDetailConstants.EDIT_VS2JEN2_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        editVs2jen2LimitedReleaseDetailLoading: false,
        editVs2jen2LimitedReleaseDetailData: action.data,
      });
    case editVs2jen2LimitedReleaseDetailConstants.EDIT_VS2JEN2_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        editVs2jen2LimitedReleaseDetailLoading: false,
        editVs2jen2LimitedReleaseDetailData: null,
        editVs2jen2LimitedReleaseDetailError: action.error,
      });
    case activateVs2jen2LimitedReleaseDetailConstants.ACTIVATE_VS2JEN2_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        activateVs2jen2LimitedReleaseDetailLoading: true,
        activateVs2jen2LimitedReleaseDetailData: null,
        activateVs2jen2LimitedReleaseDetailError: null,
      });
    case activateVs2jen2LimitedReleaseDetailConstants.ACTIVATE_VS2JEN2_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        activateVs2jen2LimitedReleaseDetailLoading: false,
        activateVs2jen2LimitedReleaseDetailData: action.data,
      });
    case activateVs2jen2LimitedReleaseDetailConstants.ACTIVATE_VS2JEN2_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        activateVs2jen2LimitedReleaseDetailLoading: false,
        activateVs2jen2LimitedReleaseDetailData: null,
        activateVs2jen2LimitedReleaseDetailError: action.error,
      });
    case deactivateVs2jen2LimitedReleaseDetailConstants.DEACTIVATE_VS2JEN2_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        deactivateVs2jen2LimitedReleaseDetailLoading: true,
        deactivateVs2jen2LimitedReleaseDetailData: null,
        deactivateVs2jen2LimitedReleaseDetailError: null,
      });
    case deactivateVs2jen2LimitedReleaseDetailConstants.DEACTIVATE_VS2JEN2_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        deactivateVs2jen2LimitedReleaseDetailLoading: false,
        deactivateVs2jen2LimitedReleaseDetailData: action.data,
      });
    case deactivateVs2jen2LimitedReleaseDetailConstants.DEACTIVATE_VS2JEN2_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        deactivateVs2jen2LimitedReleaseDetailLoading: false,
        deactivateVs2jen2LimitedReleaseDetailData: null,
        deactivateVs2jen2LimitedReleaseDetailError: action.error,
      });
    case deleteVs2jen2LimitedReleaseDetailConstants.DELETE_VS2JEN2_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        deleteVs2jen2LimitedReleaseDetailLoading: true,
        deleteVs2jen2LimitedReleaseDetailData: null,
        deleteVs2jen2LimitedReleaseDetailError: null,
      });
    case deleteVs2jen2LimitedReleaseDetailConstants.DELETE_VS2JEN2_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        deleteVs2jen2LimitedReleaseDetailLoading: false,
        deleteVs2jen2LimitedReleaseDetailData: action.data,
      });
    case deleteVs2jen2LimitedReleaseDetailConstants.DELETE_VS2JEN2_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        deleteVs2jen2LimitedReleaseDetailLoading: false,
        deleteVs2jen2LimitedReleaseDetailData: null,
        deleteVs2jen2LimitedReleaseDetailError: action.error,
      });
    default:
      return state;
  }
}
